// extracted by mini-css-extract-plugin
export default {"wrapper":"InvitationForm_wrapper__HzsXE","controlWrapper":"InvitationForm_controlWrapper__uNjgE"};